import type { FieldElement } from '../../format/form-definition';
import { useBuilder } from '../context';
import { fieldInputOf } from '../../rendering/fieldInput';
import { builtInCheckText } from '../../validations/build-in-checks';

export const CardSettings = ({ field }: { field: FieldElement }) => {
  const { edit } = useBuilder();
  const { card, settings } = fieldInputOf(field);
  const Panel = card.settingsPanel?.Panel;
  if (!Panel) return null;
  return (
    <Panel
      settings={settings}
      onChange={changes =>
        edit({ kind: 'setFieldSettings', fieldId: field.id, settings: changes as Record<string, unknown> })
      }
      builtInCheckText={builtInCheckText(field)}
    />
  );
};
